import api from "./api";

// Capa de servicios API del dominio "campañas" (campaigns) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).
// Nota: backend define GET "/campaigns" (Express non-strict => "/campaigns" == "/campaigns/").

// --- CRUD ---
export const listCampaigns = (params) => api.get("/campaigns", { params });
export const getCampaign = (campaignId) => api.get(`/campaigns/${campaignId}`);
export const getLastActiveCampaign = () => api.get("/campaigns/last-active");
export const getCampaignShipping = (campaignId, params) =>
  api.get(`/campaigns/${campaignId}/shipping`, { params });
export const createCampaign = (payload) => api.post("/campaigns", payload);
export const updateCampaign = (campaignId, payload) =>
  api.put(`/campaigns/${campaignId}`, payload);
export const deleteCampaign = (campaignId) => api.delete(`/campaigns/${campaignId}`);

// --- Media ---
export const uploadCampaignMedia = (campaignId, formData) =>
  api.post(`/campaigns/${campaignId}/media-upload`, formData);
export const deleteCampaignMedia = (campaignId) =>
  api.delete(`/campaigns/${campaignId}/media-upload`);

// --- Control de ejecución ---
export const cancelCampaign = (campaignId) =>
  api.post(`/campaigns/${campaignId}/cancel`);
export const stopCampaign = (campaignId) =>
  api.post(`/campaigns/${campaignId}/stop`);
export const restartCampaign = (campaignId) =>
  api.post(`/campaigns/${campaignId}/restart`);
